import refs from '../helpers/refs'

class CBlogArticleContent {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-blog-article-content')
    .forEach(el => new CBlogArticleContent(el))
})
